

function getRoot () {
  if (process.env.REACT_APP_ENDPOINT_ROOT) {
    return process.env.REACT_APP_ENDPOINT_ROOT
  }
  if (window.location.hostname.indexOf('ngrok') > -1) {
    return "https://9901c41f3a3a.ngrok.app/v18-sushi-mods"
  }
  if (window.location.hostname !== 'localhost') {
    return "https://p39pffu1q4.execute-api.us-west-1.amazonaws.com/v18-sushi-mods"
  }
  if (process.env.NODE_ENV === 'development') {
    return "http://localhost:3010/v18-sushi-mods"
  }
  return "https://p39pffu1q4.execute-api.us-west-1.amazonaws.com/v18-sushi-mods"
}

export default function getEndpoint (endpointPath) {
  return [getRoot(), endpointPath].join('/')
}

// true when orders go to the local sls offline API, not a deployed one
export function isLocalEndpoint () {
  return /^https?:\/\/(localhost|127\.0\.0\.1)[:/]/.test(getRoot())
}
